import { bool, func, node, string } from 'prop-types';
import React, { PureComponent } from 'react';
import BEMHelper from '@ynap/bem-helper';

const classNames = new BEMHelper('ToggleSection');

export default class ToggleSection extends PureComponent {
    static propTypes = {
        title: string.isRequired,
        description: string,
        openTitle: string,
        defaultOpen: bool,
        open: bool,
        onToggle: func,
        className: string,
        type: string,
        children: node
    };

    static defaultProps = {
        defaultOpen: false,
        type: ''
    };

    state = {
        open: typeof this.props.open === 'undefined' ? this.props.defaultOpen : this.props.open
    };

    handleClick = () => {
        if (this.props.onToggle) {
            this.props.onToggle();
        } else {
            const { open } = this.state;
            this.setState({ open: !open });
        }
    };

    render() {
        const open = this.props.onToggle ? this.props.open : this.state.open;
        const { title, openTitle, description, className, headerClassName, type, children } = this.props;

        return (
            <div className={classNames(null, null, className)}>
                <header className={classNames('header', { open }, headerClassName)}>
                    <button type="button" className={classNames('button', [type, open ? 'open' : undefined])} onClick={this.handleClick}>
                        {open && openTitle ? openTitle : title}
                        {description ? <div className={classNames('description')}>{description}</div> : null}
                    </button>
                </header>
                <div className={classNames('content', { open })}>{children}</div>
            </div>
        );
    }
}
